export default __webpack_public_path__ + "static/media/edit.f28dbb64.svg";